// import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'

export function getToken() {
  // return Cookies.get(TokenKey)
  return get(TokenKey)
}

export function getOaInfo() {
  const value = localStorage.getItem('oaInfo');
  if (value) {
    return JSON.parse(value)
  } else {
    return ''
  }
}
export function setOaInfo(value) {
  if (value) {
    return localStorage.setItem('oaInfo',JSON.stringify(value));
  } else {
    return localStorage.setItem('oaInfo','');
  }
}
export function removeOaInfo() {
  return localStorage.removeItem('oaInfo');
}


export function setToken(token) {
  return set(TokenKey, token)
  // return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return remove(TokenKey)
}

function set(key, value){
  //获取时间戳
  var curTime = new Date().getTime();
  return localStorage.setItem(key, JSON.stringify({
      data: value,
      time: curTime
  }));
}

function get(key) {
  var data = localStorage.getItem(key);
  var dataObj = JSON.parse(data);
  if (dataObj) {
    if(new Date().getTime() - dataObj.time > 3*24*60*60*1000) {
      localStorage.removeItem(key);
      return '';
    } else {
        // alert("信息没过期");
        var dataObjDatatoJson = dataObj.data
        return dataObjDatatoJson;
    }
  } else {
    return '';
  }
  
}

function remove (key) {
  localStorage.removeItem(key)
}


// WEBPACK FOOTER //
// ./src/utils/auth.js